import { cn } from '../../lib/utils'
import { Wifi, WifiOff } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip'

export type ConnectionStatusType = 'connecting' | 'connected' | 'disconnected' | 'error'

const statusConfig: Record<ConnectionStatusType, { color: string; label: string }> = {
  connected: { color: 'bg-green-500', label: 'Real-time connected' },
  connecting: { color: 'bg-yellow-500 animate-pulse', label: 'Connecting...' },
  disconnected: { color: 'bg-muted-foreground/40', label: 'Real-time disconnected' },
  error: { color: 'bg-red-500', label: 'Connection error' },
}

export interface ConnectionStatusProps {
  status: ConnectionStatusType
  className?: string
}

export function ConnectionStatus({ status, className }: ConnectionStatusProps) {
  const { color, label } = statusConfig[status]
  const Icon = status === 'error' || status === 'disconnected' ? WifiOff : Wifi

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={cn('flex items-center gap-1.5 cursor-default', className)}>
            <span className={cn('h-2 w-2 rounded-full', color)} />
            <Icon className="h-3.5 w-3.5 text-muted-foreground" />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-xs">{label}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
